/**
 * The family's enrollment for the URL's year, as the money steps need it: its
 * id, to add a payment method or pay an invoice.
 */
import { useOutletContext } from 'react-router-dom';
import type { AppLayoutContext } from '~/types';
import { useViewAsFamily } from '~/hooks/useViewAsFamily';
import { useMyFamilyQuery } from '~/pages/MyFamily/useMyFamilyQuery';
import { useEnrollYear } from '../enrollYear';

export function useFamilyEnrollmentForYear() {
  const { school } = useOutletContext<AppLayoutContext>();
  const enrollYear = useEnrollYear();
  const { familyId: viewAsFamilyId } = useViewAsFamily(school?.slug);
  const { data } = useMyFamilyQuery(
    school?.id,
    enrollYear.status === 'ready' ? enrollYear.year.id : undefined,
    viewAsFamilyId ?? undefined
  );
  const enrollment = data?.myFamily?.familyEnrollmentForYear;

  return {
    familyEnrollmentId: enrollment?.id ?? null,
  };
}
